exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!@assets/less/common.less"), "");

// module
exports.push([module.id, "\n.section-title[data-v-1fe020f8] {\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n  padding-left: 10px;\r\n  border-left: 3px solid #1890ff;\r\n  margin: 8px 0 12px;\n}\n.notice-form[data-v-1fe020f8] {\r\n  max-width: 640px;\n}\r\n", ""]);

// exports
